import { useValidationFormContext } from './validation-form';
import { getFieldPaths } from './field-paths';

export function useOrganicFieldEffects(fieldIndex: number) {
  const form = useValidationFormContext();
  const paths = getFieldPaths(fieldIndex);
  const field = form.values.fields[fieldIndex];

  form.watch(paths.organic, ({ value }) => {
    if (value === 'non') {
      form.setFieldValue(paths.lastOrganic, null);
      form.clearFieldError(paths.lastOrganic);
    }
    if (value === 'oui') {
      form.setFieldValue(paths.isValidated, false);
      form.clearFieldError(paths.isValidated);
    }
  });

  const validateLastOrganicIfNeeded = () => {
    if (field?.organic === 'oui' && !field.last_organic) {
      void form.validateField(paths.lastOrganic);
    }
  };

  return { paths, validateLastOrganicIfNeeded };
}
